import { route } from '../../../../constants.ts';
import { ZOOM_FACTOR } from '../../../utils/zoom.js';

export const SELECT_TILING = `${route}/SELECT_TILING`;
export const UPDATE_TILE = `${route}/UPDATE_TILE`;
export const UPDATE_TILING_LATTICE_ID = `${route}/UPDATE_TILING_LATTICE_ID`;
export const UPDATE_TILE_SOURCE = `${route}/UPDATE_TILE_SOURCE`;
export const UPDATE_VIEW = `${route}/UPDATE_VIEW`;
export const UPDATE_VIEW_POSITION = `${route}/UPDATE_VIEW_POSITION`;
export const UPDATE_VIEW_SCALE = `${route}/UPDATE_VIEW_SCALE`;
export const UPDATE_SHOW_LAYER = `${route}/UPDATE_SHOW_LAYER`;
export const UPDATE_SELECTION = `${route}/UPDATE_SELECTION`;
export const CHANGE_ZOOM = `${route}/CHANGE_ZOOM`;
export const SELECT_NEXT_TILING = `${route}/SELECT_NEXT_TILING`;
export const SELECT_PREV_TILING = `${route}/SELECT_PREV_TILING`;
export const CHANGE_EFFECT = `${route}/CHANGE_EFFECT`;
export const ADD_EFFECT = `${route}/ADD_EFFECT`;
export const REMOVE_EFFECT = `${route}/REMOVE_EFFECT`;
export const CHANGE_PARAM = `${route}/CHANGE_PARAM`;

export function selectTiling(tiling, lattice) {
    return {
        type: SELECT_TILING,
        payload: { tiling, lattice },
    };
}

export function updateTile({ tile, transient = false }) {
    return {
        type: UPDATE_TILE,
        payload: { tile, transient },
    };
}

export function updateTilingLatticeId({ tilingLatticeId, transient = false }) {
    return {
        type: UPDATE_TILING_LATTICE_ID,
        payload: { tilingLatticeId, transient },
    };
}

export function updateViewPosition({ position, transient = false }) {
    return {
        type: UPDATE_VIEW_POSITION,
        payload: { position, transient },
    };
}

export function updateViewScale({ scale, transient = false }) {
    return {
        type: UPDATE_VIEW_SCALE,
        payload: { scale, transient },
    };
}

export function updateView({ view, transient = false }) {
    return {
        type: UPDATE_VIEW,
        payload: { view, transient },
    };
}

export function updateShowLayer(layerId, value) {
    return {
        type: UPDATE_SHOW_LAYER,
        payload: { layerId, value },
    };
}

export function updateSelection({ type, selection, transient = false }) {
    return {
        type: UPDATE_SELECTION,
        payload: { type, selection, transient },
    };
}

export function changeZoom({ type, factor = ZOOM_FACTOR }) {
    return {
        type: CHANGE_ZOOM,
        payload: { type, factor },
    };
}

export function selectPrevTiling() {
    return {
        type: SELECT_PREV_TILING,
        payload: {},
    };
}

export function selectNextTiling() {
    return {
        type: SELECT_NEXT_TILING,
        payload: {},
    };
}

export function changeEffect({ group, index, params, transient = false }) {
    return {
        type: CHANGE_EFFECT,
        payload: { group, index, params, transient },
    };
}

export function removeEffect({ group, name, effectIndex }) {
    return {
        type: REMOVE_EFFECT,
        payload: { group, name, effectIndex },
    };
}

export function addEffect({ group, name }) {
    return {
        type: ADD_EFFECT,
        payload: { group, name },
    };
}

export function changeParam({ path, id, value, group, groupId, transient = false }) {
    return {
        type: CHANGE_PARAM,
        payload: { path, id, group, groupId, value, transient },
    };
}
